import React from 'react';
import { DateRow, LinkRow, TextRow } from 'components';
import {formatAMPMNeW, formatHours, Images, PermissionList, RolePermission} from '../../../../../utils';
import {UnitsRowByHourOneLine} from "../../../../../components/table/tableRows";

const convertUnitToHours = (minutes) => {
    let hours = Math.trunc(minutes / 60);
    let remainingMinutes = Math.trunc(minutes % 60);
    if (hours === 0) {
        return `0h ${remainingMinutes < 0 ? '-' : ''}${Math.abs(remainingMinutes)}m`;
    } else {
        return `${hours < 0 ? '-' : ''}${Math.abs(hours)}h ${Math.abs(remainingMinutes)}m`;
    }
};

// Decimal hours → "Xh Ym Zs" with no precision loss (1.2575 → "1h 15m 27s").
// Only strips float noise (e.g. 1.1 * 3600 = 3960.0000000000005), never real time.
const formatExactHours = (value) => {
    const totalSeconds = parseFloat((Math.abs(Number(value) || 0) * 3600).toFixed(6));
    const sign = Number(value) < 0 ? '-' : '';
    const hours = (totalSeconds - (totalSeconds % 3600)) / 3600;
    const minutes = ((totalSeconds % 3600) - (totalSeconds % 60)) / 60;
    const seconds = parseFloat((totalSeconds % 60).toFixed(6));
    return `${sign}${hours}h ${minutes}m${seconds ? ` ${seconds}s` : ''}`;
};

export const authorizationApptHeight = [
    { name: '', title: 'Appt ID', custom: false, noSearch: true, width: '130px' },
    { name: '', title: 'Service Date', custom: false, noSearch: true, width: '130px' },
    { name: '', title: 'Service Time', custom: false, noSearch: true, width: '130px' },
    { name: '', title: 'Client', custom: false, noSearch: true },
    { name: '', title: 'Staff ', custom: false, noSearch: true },
    { name: '', title: 'Units Completed', custom: false, noSearch: true },
    { name: '', title: ' ', custom: false, noSearch: true, width: '50px' },
];

export const authorizationApptBody = () => [
    {
        button: (cb, item) => (
            <button onClick={() => cb(item)} className="reset-btn-by-default link-btn">
                {item?.displayId}
            </button>
        ),
    },
    { rowText: (item) => <DateRow date={item?.startDate} /> },
    { rowText: (item) => <p> {`${formatAMPMNeW(item?.startTime)}-${formatAMPMNeW(item?.endTime)}`}</p> },
    {
        rowText: (item) =>
            item?.client?.fullName ? (
                <LinkRow
                    name={item?.client?.fullName}
                    href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.id}` : ''}
                    checkPermission={item?.client?.id ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                    textWidth={8}
                />
            ) : (
                '--'
            ),
    },
    {
        rowText: (item) => (
            <LinkRow
                name={item?.staff?.fullName}
                href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staff?.id}` : ''}
                checkPermission={item?.staff?.id ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                textWidth={8}
            />
        ),
    },
    {
        rowText: (item) => (
            <p>{`${Number(item?.units || 0).toFixed(2)} ${formatHours(item?.hours)}`}</p>
        ),
    },
    {
        button: (cb, item) => (
            <button onClick={() => cb(item)} className="reset-btn-by-default">
                <img src={Images.show} alt="" />
            </button>
        ),
    },
];

export const ACTION_TYPE = 'GET_AUTH_UNIT_INFO';

export const unitStatusesEnum = {
    COMPLETED: 'COMPLETED',
    PENDING: 'PENDING',
    CANCELLED: 'CANCELLED',
};
